var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarningicon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5413 5.17433C4.48688 1.72478 5.45966 0 7.00016 0C8.54066 0 9.51344 1.72477 11.459 5.17432L11.7015 5.60418C13.3182 8.47074 14.1266 9.90401 13.396 10.952C12.6654 12 10.8578 12 7.2426 12H6.75772C3.14254 12 1.33494 12 0.604334 10.952C-0.126276 9.90401 0.682104 8.47074 2.29886 5.60418L2.5413 5.17433ZM7.00016 2.83333C7.2763 2.83333 7.50016 3.05719 7.50016 3.33333V6.66667C7.50016 6.94281 7.2763 7.16667 7.00016 7.16667C6.72402 7.16667 6.50016 6.94281 6.50016 6.66667V3.33333C6.50016 3.05719 6.72402 2.83333 7.00016 2.83333ZM7.00016 9.33333C7.36835 9.33333 7.66683 9.03486 7.66683 8.66667C7.66683 8.29848 7.36835 8 7.00016 8C6.63197 8 6.3335 8.29848 6.3335 8.66667C6.3335 9.03486 6.63197 9.33333 7.00016 9.33333Z",
    fill: "#FAAD14"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warningicon.352f34dd.svg";
export { ForwardRef as ReactComponent };